import React from 'react';
import { connect } from 'react-redux';
import { Errors, actions } from 'react-redux-form';
import { get } from 'lodash';

import TextField from './TextField';
import FormError from './FormError';

const confirmSuffix = '__confirm';

function changeAndValidate(isConfirm, model, value) {
  return (dispatch, getState) => {
    const state = getState();
    const originalModel = isConfirm ?
      model.slice(0, model.length - confirmSuffix.length) :
      model;
    const confirmValue =
      model === originalModel ?
        get(state, `${originalModel}${confirmSuffix}`) :
        get(state, originalModel);
    dispatch(actions.change(model, value));
    dispatch(actions.setValidity(originalModel, {
      confirmed: value === confirmValue,
    }));
  };
}

const changeAndValidateValue = changeAndValidate.bind(null, false);
const changeAndValidateConfirm = changeAndValidate.bind(null, true);

function preventDefault(e) {
  e.preventDefault();
}

export default function EmailField(props) {
  const {
    model,
    label,
    ...otherProps,
  } = props;

  return (
    <div>
      <TextField
        model={model}
        label={label}
        inputProps={{ type: 'email' }}
        changeAction={changeAndValidateValue}
        validators={{
          // Otherwise the Field doesn't detect that it has a possible
          // confirmed validation and alternates between valid/invalid.
          confirmed: () => false,
        }}
        {...otherProps}
      />

      <TextField
        model={`${model}${confirmSuffix}`}
        label={`${label} (Confirmation)`}
        inputProps={{
          type: 'email',
          onPaste: preventDefault,
        }}
        changeAction={changeAndValidateConfirm}
      />

      <Errors
        model={model}
        component={FormError}
        show={field => field.touched && !field.focus}
        messages={{
          confirmed: 'L\'email de confirmation ne correspond pas à la valeur entrée.',
        }}
      />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/EmailField.js
 **/